import dayjs, { Dayjs } from 'dayjs';
import { getTimeDiffIgnoringTimeShift } from '@composite/calendar/utils';
import { CalendarDimensions } from '@enums';
import { CalendarSettingsType } from '../calendar-types';
import { getSecondsInPixel } from './get-seconds-in-pixel';

export function getTaskStart(
  currentDayUnix: number,
  workOrderStart: Dayjs,
  workOrderEnd: Dayjs,
  settings: Partial<CalendarSettingsType>
) {
  const {
    dimension = CalendarDimensions.WEEK,
    startingHour = 0,
    endingHour = 24,
  } = settings;

  const secondsInPixel = getSecondsInPixel(settings);

  const currentDay = dayjs.unix(currentDayUnix);

  switch (dimension) {
    case CalendarDimensions.DAY: {
      const startUnix = dayjs(workOrderStart).unix();

      const currentDayWithOffsetUnix = currentDay
        .add(startingHour, 'hour')
        .unix();

      // we need to ignore time shift (summer vs winter time), because calendar scale doesn't reflect it
      const seconds = getTimeDiffIgnoringTimeShift(
        currentDayWithOffsetUnix,
        startUnix,
        dimension
      );

      return seconds / secondsInPixel;
    }
    case CalendarDimensions.WEEK:
    case CalendarDimensions.MONTH: {
      const startUnix = dayjs(workOrderStart).unix();
      // we need to ignore time shift (summer vs winter time), because calendar scale doesn't reflect it
      const seconds = getTimeDiffIgnoringTimeShift(
        currentDayUnix,
        startUnix,
        dimension
      );

      const days = workOrderStart.diff(currentDay, 'day');

      // hidden seconds in previous days
      let hiddenSeconds = (24 - (endingHour - startingHour)) * days * 60 * 60;

      // hidden seconds in current day
      hiddenSeconds += startingHour * 60 * 60;

      // crop start time to visible hours
      if (
        workOrderStart.isBefore(
          workOrderStart.startOf('day').add(startingHour, 'hour')
        ) &&
        workOrderEnd.isAfter(
          workOrderStart.startOf('day').add(startingHour, 'hour')
        )
      ) {
        const diff =
          workOrderStart.diff(currentDay.add(days, 'day'), 'second') -
          startingHour * 60 * 60;

        hiddenSeconds += diff;
      }

      return (seconds - hiddenSeconds) / secondsInPixel;
    }
    default:
      return 0;
  }
}
